(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .constant('storeManagementConstants', {
            AUTHORITIES: {
                ADMIN_UPDATE_USER: "ADMIN_UPDATE_USER",
                STORE_UPDATE_USER: "STORE_UPDATE_USER",
                STORE_CREATE_USER: "STORE_CREATE_USER",
                ADMIN_CREATE_USER: "STORE_CREATE_USER"
            },
            ROLE_ICON: {
                EDIT: "icon-ksc-edit",
                SHOW: "fa fa-eye"
            },
            FILE: {
                SIZE: 1024,
                MAX_IMAGE_SIZE: 10240, // 10MB in KB
                UPLOAD_PROFILE_PICTURE_CONTEXT : "profilePicture",
                UPLOAD_PROFILE_BANNER_CONTEXT : "profileBanner",
                UPLOAD_PROFILE_BANNER_MOBILE_CONTEXT : "profileBannerMobile",
                DEFAULT_IMAGE_STORE: "content/images/defaultShowcaseImage.png"
            },
            GENDER: {
                MALE: "MALE",
                FEMALE: "FEMALE"
            },
            PROFILE_STORE: [
                {
                    id: "1",
                    title: "Administrator"
                },
                {
                    id: "2",
                    title: "Store Manager"
                }
            ],
            SUPPORT: {
                USER_ID: 313
            },
            SALES_POINT_ADDRESS: {
                WITHOUT_NUMBER: "s/n",
                WITHOUT_NEIGHBORHOOD: "Não Informado"
            }
        });
})();
